import { AutogenLayoutJobClassification } from "./autogen/AutogenLayoutJobClassification";
import { UrlUtil } from "@mcleod/core";

export class JobClassification extends AutogenLayoutJobClassification {
    onLoad(): void {
        this.addLayoutDataLoadListener(() => {
            const urlParams = UrlUtil.getPropsFromUrl(window.location.href);
            if (urlParams) {
                this.mainDataSource.search({
                    id: urlParams.key,
                    division_id: urlParams.divisionId,
                    terminal_id: urlParams.terminalId
                }, null, this.layoutName).then(() => {
                    this.dataHeader.syncTitle();
                });
            }
        });
    }
}
